export default "/fonts/vendor/fontsource-roboto/files/roboto-greek-ext-400-italic.woff2?26c1478a1bb6b2c2c6b09bccb2b5b9c6";